import type {
  GetDocumentsUserRolesRequestType,
  GetDocumentsUserRolesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentsUserRoles = async (
  params: GetDocumentsUserRolesRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/user-roles`;
  const response =
    await apiAuthClient.get<GetDocumentsUserRolesResponseType>(url);

  return response.data.data;
};
